import React from 'react';

import Button from '../../../components/ui/Button';

const BulkActions = ({ 
  selectedCount, 
  onExportSelected, 
  onMarkAsReviewed, 
  onDeleteSelected,
  onClearSelection,
  isProcessing = false 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-20 md:bottom-20 left-4 right-4 z-30">
      <div className="bg-card border border-border rounded-lg security-shadow-modal glass-morphism p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-accent/10 text-accent px-3 py-1 rounded-full text-sm font-medium">
              {selectedCount} selected
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              className="text-muted-foreground hover:text-foreground"
            >
              Clear
            </Button>
          </div>

          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onExportSelected}
              loading={isProcessing}
              iconName="Download"
              className="hidden sm:flex"
            >
              Export Selected
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={onMarkAsReviewed}
              loading={isProcessing}
              iconName="Eye"
              className="hidden sm:flex"
            >
              Mark Reviewed
            </Button>

            <Button
              variant="destructive"
              size="sm"
              onClick={onDeleteSelected}
              loading={isProcessing}
              iconName="Trash2"
              className="hidden sm:flex"
            >
              Delete
            </Button>

            {/* Mobile Actions Menu */}
            <div className="sm:hidden flex items-center space-x-1">
              <Button
                variant="outline"
                size="sm"
                onClick={onExportSelected}
                loading={isProcessing}
                iconName="Download"
              />
              
              <Button
                variant="outline"
                size="sm"
                onClick={onMarkAsReviewed}
                loading={isProcessing}
                iconName="Eye"
              />

              <Button
                variant="destructive"
                size="sm"
                onClick={onDeleteSelected}
                loading={isProcessing}
                iconName="Trash2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;